import React from 'react';
import styled from 'styled-components';

const AboutRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 900px;
  width: 100%;
  margin: 64px auto 0 auto;
  padding: 0 2vw;
  gap: 42px;
  min-height: 220px;

  @media (max-width: 900px) {
    gap: 20px;
  }

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: center;
    gap: 16px;
    min-height: unset;
    margin-top: 36px;
  }
`;

const PhotoSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 125px;

  @media (max-width: 900px) {
    min-width: 92px;
  }
`;

const ProfileImage = styled.img`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #233056;
  box-shadow: 0 2px 12px rgba(40,60,100,0.10);
  background: #121620;

  @media (max-width: 900px) {
    width: 130px;
    height: 130px;
  }
`;


const Arrow = styled.div`
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -12px;
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 22px solid #1e2737;
  z-index: 1;

  @media (max-width: 650px) {
    display: none; 
  }
`;

const Bubble = styled.div`
  background: linear-gradient(110deg, #1e2737 90%, #142538 100%);
  padding: 24px 38px;
  min-width: 360px;
  max-width: 570px;
  width: 100%;
  border-radius: 22px 18px 15px 12px/18px 18px 18px 12px;
  box-shadow: 0 2px 8px rgba(40,60,80,0.10);
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 900px) {
    padding: 14px 6vw;
    min-width: 0;
    max-width: none;
  }
  @media (max-width: 650px) {
    border-radius: 14px 12px 12px 10px/14px 12px 12px 10px;
    padding: 13px 3vw;
    min-width: 0;
    margin-top: 0;
  }
`;

const Name = styled.h1`
  margin: 0 0 4px 0;
  font-size: 2rem;
  font-weight: 600;
  color: #70a4fa;
  @media (max-width: 480px) {
    font-size: 1.15rem;
  }
`;

const Subheading = styled.h2`
  margin: 0 0 13px 0;
  font-size: 1.50rem;
  color: #dbe0f3;

  @media (max-width: 480px) {
    font-size: 0.94rem;
    margin-bottom: 10px;
  }
`;

const Description = styled.p`
  color: #e1e7f7;
  font-size: 1.15em;
  line-height: 1.62;
  margin: 0;
  margin-top: 1px;
  @media (max-width: 480px) {
    font-size: 0.98em;
    line-height: 1.48;
  }
`;

const About = () => (
  <AboutRow id="about">
    <PhotoSide>
      <ProfileImage src={`${process.env.PUBLIC_URL}/Amirtha_photo.jpg`} alt="Profile" />
      <Arrow />
    </PhotoSide>
    <Bubble>
      <Name>Hello!</Name>
      <Subheading>I'm Amirthavarshini</Subheading>
      <Description>
        I am currently pursuing a Bachelor's degree in Computer Science and Engineering with a specialization in Artificial Intelligence at Amrita Vishwa Vidyapeetham, Chennai, India.<br /><br />
        I am a passionate engineer dedicated to developing solutions for social good, with particular interests in software development, natural language processing, and data analytics.<br /><br />
        In my free time, I love learning about the environment and sustainable living. I am a quick learner, well-organized, and thrive on solving complex problems.<br /><br />
        Feel free to reach out for collaborations on projects or hackathons, or to provide suggestions and comments on my existing work. Let's connect and create something impactful together!
      </Description>
    </Bubble>
  </AboutRow>
);

export default About;
